import DottedSeparator from "common/components/DottedSeparator";
import PoweredByStripe from "common/components/PoweredByStripe";
import { DialogHeader } from "common/components/ui/Dialog/Dialog";

import type { JSX } from "react";

export default function DesktopLayout({
  subscriptionPlanComponent,
  pricingPeriodSelectionComponent,
  quantitySelectionComponent,
  pricingComponent,
  paymentSourceComponent,
  estimateComponents,
}: {
  subscriptionPlanComponent: JSX.Element;
  pricingPeriodSelectionComponent: JSX.Element;
  quantitySelectionComponent: JSX.Element;
  pricingComponent: JSX.Element;
  paymentSourceComponent: JSX.Element;
  estimateComponents: JSX.Element;
}) {
  return (
    <>
      <DialogHeader>Manage subscription</DialogHeader>
      <div className="flex gap-x-8 px-8 pt-8 pb-9 items-start">
        <div className="flex-1 flex flex-col">
          {subscriptionPlanComponent}
          <DottedSeparator className="my-6" />
          {pricingPeriodSelectionComponent}
          <label
            className="ml-1 mb-1.5 text-black-400 text-button-xs inline-flex"
            htmlFor="seats-spinner"
          >
            Seats
          </label>
          <div className="flex items-center rounded-2xl p-2.5 border border-black-200">
            {pricingComponent}
            {quantitySelectionComponent}
          </div>
          <DottedSeparator className="my-6" />
          <span className="ml-1 mb-1.5 text-black-400 text-button-xs inline-flex">
            Pay with
          </span>
          {paymentSourceComponent}
        </div>
        <div className="bg-whiteGray flex flex-col pb-2.5 rounded-4xl flex-1 p-2 gap-y-3">
          {estimateComponents}
          <PoweredByStripe />
        </div>
      </div>
    </>
  );
}
